import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';
import OrderAlertTable from './OrderAlertTable';

const OrderTimingAlert = (props) => {
  const { alert } = props;
  const { 
    percentage_of_untimely_checkouts,
    supplier_name,
    time_operator,
    time,
    orders
  } = alert.value;

  return (
    <AlertItem
      alert={alert}
      date={moment(alert.date).format('MMMM Do, YYYY')}
      icon='cubes'
      title={(
        <div>
          <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
            {alert.buyer.name}
          </Link>
          {' '}placed over{' '}
          <strong className='u-colorRed'>
            {percentage_of_untimely_checkouts}
          </strong>
          {' '} of their orders {time_operator}{' '}{time}{' '}in their own timezone from {supplier_name}{'. '}
        </div>
      )}
      content={(
        <OrderAlertTable includeExport={true} orders={orders} showTime={true} type={alert.type} />
      )}
      {...props}
    />
  );
};


OrderTimingAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default OrderTimingAlert;
